import { isProdEnvironment } from 'utils/environment';

/**
 * Draft mode is enabled when`draftMode().isEnabled` returns true.  This is never true in production.
 * see also src/app/api/draft/route.ts (the web entry point for enabling draft mode)
 *
 * A) primary mechanism: the contentful live preview interface hits our API endpoint at src/app/api/draft/route.ts
 * B) dev only: the localhost env variable `CONTENTFUL_DRAFT_PREVIEW_MODE` is set (used in local dev only to allow draft content to render always)
 */
export const isDraftPreviewEnabled = async (): Promise<boolean> => {
  if (isProdEnvironment()) {
    return false;
  }

  // importing headers here in-line allows
  // this function to be used both client + server-side
  const { draftMode } = await import('next/headers');
  return (await draftMode()).isEnabled || process.env.CONTENTFUL_DRAFT_PREVIEW === 'enabled';
};
